import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { RootState } from '../../store';
import { Container, Content } from './styles';
import BackArrow from '../../components/BackArrow';

import { loginWithToken } from '../../store/Auth.store';
import { api2 } from '../../services/api';
import Loader from '../../components/Loader';
import { VirtualRaceType } from '../../types/VirtualRace';
import VirtualRaceCardList from '../../components/VirtualRaceCardList';

export default function VirtualRaceList() {
  const [searchParms] = useSearchParams();
  const dispatch = useDispatch();

  const token = searchParms.get('token');
  const err = searchParms.get('err');

  const _loginWithToken = async () => {
    if (err) {
      window.location.href = '/login';
      return;
    }
    if (token) {
      const data = JSON.parse(atob(token.split('.')[1]));
      await dispatch(loginWithToken(data.uid, token) as any);
    }
  };

  useEffect(() => {
    _loginWithToken();
  }, [token]);

  const navigate = useNavigate();
  const auth = useSelector((state: RootState) => state.auth);
  const { user } = auth;
  const { id, company_id, companies } = user;

  const [virtualRace, setVirtualRace] = useState<VirtualRaceType[]>();
  const [loading, setLoading] = useState(false);

  const getVirtualRaces = async () => {
    setLoading(true);
    api2.get('/virtual-race')
      .then(((response) => {
        setVirtualRace(response.data);
      })).catch(() => {
        toast.error('Erro ao carregar as corridas virtuais.');
      }).finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getVirtualRaces();
  }, []);

  return (
    <Container>
      {id
        && (
          <BackArrow text="Corridas Virtuais" bigger backTo="/club/challenge-list" />
        )}
      <Content>
        {!loading && virtualRace?.map(({
          banner, medal, title, description, distances, slug, companyId, isCompanyRace, medalBanner,
        }, index) => (
          ((isCompanyRace && (company_id === companyId || companies?.some((company) => company.id === companyId))) || !isCompanyRace) && (
            <VirtualRaceCardList
              key={index}
              action={() => navigate(slug)}
              image={banner}
              medal={medal}
              title={title}
              info={description}
              distances={distances}
              medalBanner={medalBanner}
            />
          )
        ))}
        {loading && <Loader color="white" />}
      </Content>
    </Container>
  );
}
